import { useDispatch, useSelector } from "react-redux";
import NewQuestion from "./question";
import { setShowError } from "../../../../redux/slice/rfpModuleSlice/application";
import { getRefinementQuestion } from "../../../../redux/slice/rfpModuleSlice/build";
import { useSearchParams } from "react-router-dom";
import { getFileList } from "../../../../redux/slice/rfpModuleSlice/overview";
import { useEffect, useState } from "react";
import { useWebSocket } from "api/websocket";
import { AppDispatch, RootState } from "redux/store";
import Loading from "style-guide/component/Loader";
import QuestionProgress from "style-guide/component/QuestionProgress";
import Typography from "style-guide/component/Typography";
import Breadcrumb from "style-guide/component/Breadcrumb";

const Refine = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { clearMessage } = useWebSocket();
  const [searchParams, setSearchParams] = useSearchParams();

  const initialQuestionIndex =
    Number(searchParams.get("currentQuestion")) ||
    Number(localStorage.getItem("currentQuestion")) ||
    0;

  const [currentQuestion, setCurrentQuestion] =
    useState<number>(initialQuestionIndex);
  const { refinementQuestion } = useSelector(
    (state: RootState) => state.buildData
  );

  const { isLoading } = useSelector(
    (state: RootState) => state.applicationData
  );

  useEffect(() => {
    clearMessage();
    const maxAttempts = 5;
    let attempts = 0;

    const fetchRefinementQuestion = async () => {
      try {
        attempts++;
        const response = await dispatch(getRefinementQuestion());
        if (response !== 500 && response !== 502 && response !== 400) {
          return;
        }

        if (attempts < maxAttempts) {
          await fetchRefinementQuestion();
          dispatch(setShowError({ showError: false }));
        } else {
          dispatch(setShowError({ showError: true }));
        }
      } catch (error) {
        if (attempts < maxAttempts) {
          await fetchRefinementQuestion();
        } else {
          dispatch(setShowError({ showError: true }));
        }
      }
    };

    fetchRefinementQuestion();

    dispatch(getFileList("RFP"));
  }, []);

  return (
    <div className="flex flex-col gap-4 pr-4">
      <div className="flex flex-row justify-between">
        <Typography
          text="Nozma"
          variant="LG"
          className="text-blue-primary"
          strong
        />
      </div>
      <Breadcrumb
        items={[
          {
            label: "RFP Strategy",
            link: "",
            isActive: false,
          },
          { label: "Refine Requirements", link: "/", isActive: true },
        ]}
        theme="light"
      />

      <QuestionProgress
        value={currentQuestion + 1}
        max={refinementQuestion.length}
      />

      {currentQuestion === 0 && (
        <div className="flex flex-col gap-2">
          <Typography
            variant="Heading 3"
            text="To help customize your RFP requirements, we need a few additional details."
          />
          <Typography
            variant="LG"
            text="Your responses will help us generate a targeted evaluation strategy that aligns with your unique needs."
          />
        </div>
      )}

      {isLoading ? (
          <div className="fixed inset-0 flex items-center justify-center z-[9999] text-center">
            <Loading mainHeading="Generating the Refinement Questions" />
          </div>
      ) : (
        <NewQuestion
          refine={refinementQuestion as any}
          searchParams={searchParams}
          setCurrentQuestion={setCurrentQuestion}
          currentQuestion={currentQuestion}
          setSearchParams={setSearchParams}
        />
      )}
    </div>
  );
};

export default Refine;
